const THEME = {
  primary: '#5354A4',
  order: {
    shop: {
      color: '#E1E8FF',
      textColor: '#5354A4'
    },
    takeaway: {
      color: '#DAF8E6',
      textColor: '#22AD5C'
    },
    delivery: {
      color: '#FCF1FE',
      textColor: '#D345F8'
    },
    openbill: {
      color: '#FFF4DB',
      textColor: '#D48806'
    }
  },
  table: {
    textColor: {
      available: '#5354A4',
      hold: '#DEE2E6',
      occupied: '#DEE2E6'
    },
    color: {
      available: '#DEE2E6',
      hold: '#5354A4',
      occupied: '#F59460'
    }
  }
};

export default THEME;
